import React, { Component } from 'react'
import '../styles/Reports.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIGenericRequest from '../api/APIGenericRequest'
import APIReportRequest from '../api/APIReportRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import AlertMessage from '../widgets/AlertMessage'
import DatePicker from '../widgets/DatePicker'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'

class ReportsRegional extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			regionId: user.region_id,
			disabled: props.disabled
		}
		this.getFarmerRegistrationSummaryByRegionId = this.getFarmerRegistrationSummaryByRegionId.bind(this)
		this.getFarmerClusteringSummaryPerSiteByRegionId = this.getFarmerClusteringSummaryPerSiteByRegionId.bind(this)
		this.getSWGSummaryPerProvinceByRegionId = this.getSWGSummaryPerProvinceByRegionId.bind(this)
		this.getOrganizaionSummaryPerProvinceByRegionId = this.getOrganizaionSummaryPerProvinceByRegionId.bind(this)
		this.getProvinceCommitmentsByRegionIdCropIdAndDateRange = this.getProvinceCommitmentsByRegionIdCropIdAndDateRange.bind(this)
		this.getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange = this.getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange.bind(this)
		this.getFarmersInvolvedPerProvinceByYearAndRegionId = this.getFarmersInvolvedPerProvinceByYearAndRegionId.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	getFarmerRegistrationSummaryByRegionId(regionId) {
		const ext = APIReportRequest.getFarmerRegistrationSummaryByRegionId(this.state.accessToken, regionId)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getFarmerClusteringSummaryPerSiteByRegionId(rid) {
		const ext = APIReportRequest.getFarmerClusteringSummaryPerSiteByRegionId(this.state.accessToken, rid)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getProvinceCommitmentsByRegionIdCropIdAndDateRange(rid, crid, start, end) {
		const ext = APIReportRequest.getProvinceCommitmentsByRegionIdCropIdAndDateRange(this.state.accessToken, rid, crid, start, end)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange(rid, start, end, members) {
		const ext = APIReportRequest.getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange(this.state.accessToken, rid, start, end)
		ext.then((response) => {
			console.log('getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange', response, members)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			response.results.map((item, i) => {
				members[item.province]['gross_income'] = item.gross_income
				members[item.province]['net_income'] = item.net_income
			})
			const clusters = Object.values(members)
			const data = {
				region: this.state.region,
				site: localStorage.getItem("siteName"),
				clusters: clusters
			}
			this.setState({
				data: data,
				showActivityIndicator: false
			})
		})
	}

	getFarmersInvolvedPerProvinceByYearAndRegionId(rid, year, start, end) {
		const ext = APIReportRequest.getFarmersInvolvedPerProvinceByYearAndRegionId(this.state.accessToken, rid, year)
		ext.then((response) => {
			console.log('getFarmersInvolvedPerProvinceByYearAndRegionId', rid, year, response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const members = {}
			response.results.map((item, i) => {
				members[item.province] = item
			})
			this.getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange(rid, start, end, members)
		})
	}

	getSWGSummaryPerProvinceByRegionId(rid) {
		const ext = APIReportRequest.getSWGSummaryPerProvinceByRegionId(this.state.accessToken, rid)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results.data,
				showActivityIndicator: false
			})
		})
	}

	getOrganizaionSummaryPerProvinceByRegionId(siteId) {
		this.setState({showActivityIndicator: true})
		const obi = APIReportRequest.getOrganizaionSummaryPerProvinceByRegionId(this.state.accessToken, siteId)
		obi.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				data: response.results.data,
				showActivityIndicator: false
			})
		})
	}

	handleFooterEvent(e) {
		if(this.state.data == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "No data for export. Please generate report."
			})
			return;
		}
		const dateObj = new Date()
		const month = dateObj.getMonth() + 1
		const date = month + "-" + dateObj.getDate() + "-" + dateObj.getFullYear()
		switch(this.state.typeId) {
			case 1:
				var filename = "RegisteredFarmersRegionalReport-" + date;
				break
			case 2:
				filename = "ClusterMembersRegionalReport-" + date;
				break
			case 3:
					filename = "CollectiveMarketingRegionalReport-" + date;
				// if(this.state.subTypeId == 1) {
				// 	filename = "CollectiveMarketingClusterRegionalReport-" + date;
				// }
				// else {
				// 	filename = "CollectiveMarketingMemberRegionalReport-" + date;
				// }
				break
			case 4:
				filename = "AEStepsTrackingRegionalReport-" + date;
				break
			case 5:
				filename = "CommitmentsRegionalReport-" + date;
				break
			case 6:
				filename = "SWGMembersRegionalReport-" + date;
				break
			case 7:
				filename = "OrganizationsRegionalReport-" + date;
		}
		// exportToCSV(this.state.data, filename, this.state.typeId, this.state.subTypeId, this.state.dateRange, this.state.year, this.state.focusCrop)
		this.getServerDateTime(filename)
	}

	getServerDateTime(filename) {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const dateTime = new Date(response.results.date_time)
			exportToCSV(
				this.state.data,
				filename,
				this.state.typeId,
				this.state.dateRange,
				this.state.year,
				this.state.focusCrop,
				dateTime
			)
		})
	}

	render() {
		const view = <div id="report-site">
			<div className="report-details-left"><FilterReport siteId={this.state.siteId} generate={(v) => {
				switch(parseInt(v.typeId)) {
					case 1:
						this.getFarmerRegistrationSummaryByRegionId(this.state.regionId)
					break
					case 2:
						this.getFarmerClusteringSummaryPerSiteByRegionId(this.state.regionId)
					break
					case 3:
						this.getFarmersInvolvedPerProvinceByYearAndRegionId(this.state.regionId, v.year, v.start, v.end)
					break
					case 4:
					break
					case 5:
						this.getProvinceCommitmentsByRegionIdCropIdAndDateRange(this.state.regionId, v.cropId, v.start, v.end)
					break
					case 6:
						this.getSWGSummaryPerProvinceByRegionId(this.state.regionId)
					break
					case 7:
						this.getOrganizaionSummaryPerProvinceByRegionId(this.state.regionId)
				}
				this.setState({
					typeId: parseInt(v.typeId),
					period: {from: v.start, to: v.end},
					year: v.year,
					focusCrop: v.focusCrop,
					dateRange: `${formatDate(v.start)} - ${formatDate(v.end)}`,
					data: null
				})
			}} /></div>
			<div className="report-details-right2">
				<ReportContent data={this.state.data} typeId={this.state.typeId} subTypeId={this.state.subTypeId}
					year={this.state.year} dateRange={this.state.dateRange} focusCrop={this.state.focusCrop} />
				<div className='reports-footer'>
					<OrgFooter eventHandler={this.handleFooterEvent}
						showSubmit={false}
						showExport={true} />
				</div>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FilterReport extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		let m = date.getMonth()+1
		if(m < 10) {
			m = `0${m}`
		}
		this.state = {
			reportType: "COLLECTIVE MARKETING",
			types: [
				{id: 1, name: "REGISTERED FARMERS"},
				{id: 2, name: "CLUSTER MEMBERS"},
				{id: 4, name: "AE STEPS TRACKING"},
				{id: 6, name: "SWG MEMBERS"},
				{id: 7, name: "ORGANIZATIONS"},
				{id: 3, name: "COLLECTIVE MARKETING"},
				{id: 5, name: "COMMITMENTS"},
			],
			type: '-- SELECT --',
			disableDate: true,
			crops: JSON.parse(localStorage.getItem("crops")),
			endDate: date.getFullYear() + '-' + m + '-' + date.getDate()
		}
		this.getAllCrops = this.getAllCrops.bind(this)
	}

	getAllCrops() {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name, key:v.crop_id})
			}
			localStorage.setItem("crops", JSON.stringify(c))
		})
	}

	render() {
		const view = <div className="filter-report">
			<div>Type of Report:</div>
			<DropdownWidget list={this.state.types} placeholder={this.state.type} onItemSelected={(id, val) => {
				let disable = true
				if(id == 3 || id == 5) {
					disable = false
				}
				this.setState({
					typeId: id,
					disableDate: disable,
					showTypeMSG: false,
					showDateMSG: false
				})
			}} />
			{this.state.showTypeMSG && <div style={{color: '#c96f6f'}}>* Select type of report</div>}
			<br />
			{this.state.typeId == 5 && <div>
				<div id="tc-cell1-i2">
					<div>Focus Crop</div>
					<InputTextFilterWidget list={this.state.crops} placeholder={this.state.targetCrop}
						onItemSelected={(id, val) => {
							this.setState({cropId: id, showCropMSG: false, targetCrop: val})
						}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
				</div>
				{this.state.showCropMSG && <div style={{color: '#c96f6f', 'margin-top': '2px'}}>* Select focus crop</div>}
				<br />
			</div>}
			{(this.state.typeId == 4 || this.state.typeId == 5 || this.state.typeId == 3) && <div>
				<div style={{'margin-bottom': '5px'}}>From Date:</div>
				<DatePicker onChange={(value) => {
					const v = value.split('-')
					const endDate =  this.state.endDate.split('-')
					const endYear = endDate[0]
					let maxEndDate = this.state.endDate
					if(endYear != v[0]) {
						maxEndDate = `${v[0]}-12-31`
					}
					this.setState({
						startDate: value,
						year: v[0],
						endDate: maxEndDate
					})
				}} value={this.state.startDate} max={this.state.endDate} disabled={this.state.disableDate} />
				<br />
				<div style={{'margin-bottom': '5px'}}>To Date:</div>
				<DatePicker onChange={(value) => {
					const v = value.split('-')
					const startDate =  this.state.startDate.split('-')
					const startYear = startDate[0]
					let minStartDate = this.state.startDate
					let year = startDate[0]
					if(startYear != v[0]) {
						minStartDate = `${v[0]}-1-1`
						year = v[0]
					}
					this.setState({
						startDate: minStartDate,
						year: year,
						endDate: value
					})
				}} value={this.state.endDate} min={this.state.startDate} disabled={this.state.disableDate} />
				{this.state.showDateMSG && <div style={{color: '#c96f6f', 'margin-top': '2px'}}>* Select date range</div>}
			</div>}
			<br />
			<button className="green-two" onClick={(k, v) => {
				if(this.state.typeId == null) {
					this.setState({showTypeMSG: true})
					return
				}
				if(this.state.typeId == 5 && this.state.cropId == null) {
					this.setState({showCropMSG: true})
					return
				}
				if((this.state.typeId == 5 || this.state.typeId == 3) && (this.state.startDate == null && this.state.endDate == null)) {
					this.setState({showDateMSG: true})
					return
				}
				const filter = {
					typeId: this.state.typeId,
					intervalId: this.state.intervalId,
					year: this.state.year,
					cropId: this.state.cropId,
					start: this.state.startDate,
					end: this.state.endDate,
					focusCrop: this.state.targetCrop
				}
				this.props.generate(filter)
				this.setState({
					showCropMSG: false,
					showDateMSG: false,
					showTypeMSG: false
				})
			}}>GENERATE</button>
			<button className="green-two" onClick={(k, v) => {
				const filter = {
					typeId: null,
				}
				this.props.generate(filter)
				const date = new Date()
				const m = date.getMonth()+1
				this.setState({
					typeId: null,
					startDate: null, 
					endDate: date.getFullYear() + '-' + m + '-' + date.getDate(),
					showCropMSG: false,
					showDateMSG: false,
					showTypeMSG: false,
					type: null
				})
			}}>CLEAR</button>
		</div>
		return(view)
	}
}

class ReportContent extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			region: user.region,
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data && this.props.data != null) {
			console.log(this.props.data)
			let totalClusters = 0
			let totalSites = 0
			// this.props.data.clusters.map((item, i) => {
			let data = this.props.data
			if(!Array.isArray(data)) {
				data = this.props.data.clusters
			}
			// this.props.data.map((item, i) => {
			data.map((item, i) => {
				if(item.cluster_count != null) {
					totalClusters += item.cluster_count
				}
				else if(item.cluster_involved != null) {
					totalClusters += item.cluster_involved
				}
				if(item.site_count != null) {
					totalSites += item.site_count
				}
				else if(item.site_involved != null) {
					totalSites += item.site_involved
				}
			})
			this.setState({
				data: this.props.data,
				siteCount: (totalSites != 0)? totalSites: this.props.data.length,
				totalClusters: totalClusters,
				year: this.props.year,
				typeId: this.props.typeId,
				dateRange: this.props.dateRange,
				focusCrop: this.props.focusCrop
			})
		}
		if(prevProps.data != this.props.data && this.props.data == null) {
			this.setState({data: null})
		}
	}

	render() {
		const view = <div id="report-content">
			{this.props.data != null && <div className="rcf-content">
				<div>
				<table className="rcf-table-one">
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<tr>
						<th>REGION</th>
						<th>TOTAL NO. OF SITES</th>
						{(this.state.typeId != 1 && this.state.typeId != 7 && this.state.typeId != 6) && <th>TOTAL NO. OF CLUSTERS</th>}
						{(this.state.typeId == 5) && <th>FOCUS CROP</th>}
						{(this.state.typeId == 5 || this.state.typeId == 3) && <th>DATE RANGE</th>}
					</tr>
					<tr>
						<td><div>{this.state.region}</div></td>
						<td><div>{this.state.siteCount}</div></td>
						{(this.state.typeId != 1 && this.state.typeId != 7 && this.state.typeId != 6) && <td><div>{this.state.totalClusters}</div></td>}
						{(this.state.typeId == 3 && this.state.subTypeId == 2) && <td><div>{this.state.year}</div></td>}
						{(this.state.typeId == 5) && <td><div>{this.state.focusCrop}</div></td>}
						{(this.state.typeId == 5 || this.state.typeId == 3 || this.state.typeId == 4) && <td><div>{this.state.dateRange}</div></td>}
					</tr>
				</table>
				{this.props.typeId == 1 && <RegisteredFarmers data={this.state.data}/>}
				{this.props.typeId == 2 && <ClusterMembers data={this.state.data}/>}
				{this.props.typeId == 3 && <ClustersInvolved data={this.state.data}/>}
				{this.props.typeId == 5 && <Commitments data={this.state.data}/>}
				{this.props.typeId == 6 && <SWGMembers data={this.state.data}/>}
				{this.props.typeId == 7 && <SiteOrganizations data={this.state.data}/>}
			</div>
			</div>}
		</div>
		return(view)
	}
}

const RegisteredFarmers = (props) => {
	const sites = []
	if(props.data) {
		props.data.map((item, i) => {
			sites.push(<SiteRF data={item} key={Math.random()} />)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='11'>REGISTERED FARMERS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>MUNICIPALITY</th>
			<th rowspan='2'>SITE NAME</th>
			<th colspan='3'>ARBs</th>
			<th colspan='3'>NON-ARBs</th>
			<th rowspan='2'>Rural women under<br/>speical circumstances<br/>(ARB and Non-ARB)</th>
			<th rowspan='2'>TOTAL</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
		</tr>
		{sites}
	</table>)
}

const SiteRF = (props) => {
	return(	<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.city}</div></td>
		<td><div>{props.data?.site}</div></td>
		<td><div>{props.data?.arb_male}</div></td>
		<td><div>{props.data?.arb_female}</div></td>
		<td><div>{props.data?.total_arb}</div></td>
		<td><div>{props.data?.non_arb_male}</div></td>
		<td><div>{props.data?.non_arb_female}</div></td>
		<td><div>{props.data?.total_non_arb}</div></td>
		<td><div>{props.data?.rural_women_with_circumstance}</div></td>
		<td><div>{props.data?.total_registered}</div></td>
	</tr>)
}

const ClusterMembers = (props) => {
	const sites = []
	if(props.data) {
		props.data.map((item, i) => {
			sites.push(<SiteCM data={item} key={Math.random()} />)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='14'>TOTAL CLUSTER MEMBERS AND OFFICERS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>SITES</th>
			<th rowspan='2'>NUMBER OF<br/>CLUSTERS</th>
			<th colspan='3'>ARBs</th>
			<th colspan='3'>NON-ARBs</th>
			<th rowspan='2'>Rural women under<br/>speical circumstances<br/>(ARB and Non-ARB)</th>
			<th rowspan='2'>TOTAL</th>
			<th colspan='3'>ARB Representative</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
		</tr>
		{sites}
	</table>)
}

const SiteCM = (props) => {
	return(	<tr> 
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.site.toUpperCase()}</div></td>
		<td><div>{props.data?.cluster_count}</div></td>
		<td><div>{props.data?.arb_male}</div></td>
		<td><div>{props.data?.arb_female}</div></td>
		<td><div>{props.data?.total_arb}</div></td>
		<td><div>{props.data?.non_arb_male}</div></td>
		<td><div>{props.data?.non_arb_female}</div></td>
		<td><div>{props.data?.total_non_arb}</div></td>
		<td><div>{props.data?.rural_women_with_circumstance}</div></td>
		<td><div>{props.data?.total_clustered}</div></td>
		<td><div>{props.data?.non_arb_male}</div></td>
		<td><div>{props.data?.non_arb_female}</div></td>
		<td><div>{props.data?.total_non_arb}</div></td>
	</tr>)
}

const ClustersInvolved = (props) => {
	const items = []
	if(props.data != null && props.data.clusters != null) {
		props.data.clusters.map((item, i) => {
			items.push(<MembersInvolvedItem data={item}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='13'>COLLECTIVE MARKETING - CLUSTERS INVOLVED</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>NUMBER OF SITES</th>
			<th rowspan='2'>TOTAL NO. OF CLUSTERS</th>
			<th colspan='3'>ARBS</th>
			<th colspan='3'>NON-ARBs</th>
			<th rowspan='2'>Rural women under<br/>speical circumstances<br/>(ARB and Non-ARB)</th>
			<th rowspan='2'>TOTAL</th>
			<th rowspan='2'>TOTAL GROSS INCOME</th>
			<th rowspan='2'>TOTAL NET INCOME</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
		</tr>
		{items}
	</table>)
}

const MembersInvolvedItem = (props) => {
	return(	<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{`${props.data.site_involved}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.cluster_involved}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.arb_male}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.arb_female}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.total_arb}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.non_arb_male}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.non_arb_female}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.total_non_arb}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.rural_women_with_circumstance}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.total_involved}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{formatCurrency(props.data.gross_income)}</div></td>
		<td><div>{formatCurrency(props.data.net_income)}</div></td>
	</tr>)
}

const Commitments = (props) => {
	const items = []
	if(props.data != null) {
		props.data.map((item, i) => {
			items.push(<CommitmentsItem data={item}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='6'>COMMITMENTS PER SITE</th>
		</tr>
		<tr>
			<th>PROVINCE</th>
			<th>NUMBER OF SITES</th>
			<th>TOTAL NO. OF CLUSTERS</th>
			<th>TOTAL AREA PLANTED</th>
			<th>COMMITMENT VOLUME</th>
			<th>FINAL COMMITTED VOLUME</th>
		</tr>
		{items}
	</table>)
}

const CommitmentsItem = (props) => {
	const total = parseInt(props.data?.total) + parseInt(props.data?.in_organization)
	return(<tr>
		<td><div>{props.data?.province.toUpperCase()}</div></td>
		<td><div>{`${props.data.site_count}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.cluster_count}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.area_planted}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.supply_commitment}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.evaluated_supply}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
	</tr>)
}

const SWGMembers = (props) => {
	const items = []
	if(props.data != null) {
		props.data.map((item, i) => {
			items.push(<SiteSWG data={item}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='6'>SITE WORKING GROUP MEMBERS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>NUMBER OF SITES</th>
			<th colspan='2'>SWGs</th>
			<th rowspan='2'>IN AN<br/>ORGANIZATION</th>
			<th rowspan='2'>TOTAL</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
		</tr>
		{items}
	</table>)
}

const SiteSWG = (props) => {
	return(	<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.site_count}</div></td>
		<td><div>{props.data?.male}</div></td>
		<td><div>{props.data?.female}</div></td>
		<td><div>{props.data?.in_organization}</div></td>
		<td><div>{props.data?.total}</div></td>
	</tr>)
}

const SiteOrganizations = (props) => {
	const items = []
	if(props.data != null) {
		props.data.map((item, i) => {
			items.push(<SiteARBO data={item}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='11'>TOTAL NO. OF ORGANIZATIONS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>NUMBER OF SITES</th>
			<th colspan='9'>ARBO TYPE</th>
		</tr>
		<tr>
			<th>ARB COOP</th>
			<th>CONSUMER</th>
			<th>CREDIT</th>
			<th>FARMER MPC</th>
			<th>MARKETING</th>
			<th>MULTI PURPOSE (AGRI)</th>
			<th>MULTI PURPOSE (NON-AGRI)</th>
			<th>PRODUCERS</th>
			<th>TOTAL NO. OF ORGANIZATIONS</th>
		</tr>
		{items}
	</table>)
}

const SiteARBO = (props) => {
	return(<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.site_count}</div></td>
		<td><div>{`${props.data.arb_cooperative}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.consumer}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.credit}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.farmers_mpc}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.marketing}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.multi_purpose_agri}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.multi_purpose_non_agri}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.producers}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
		<td><div>{`${props.data.total}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</div></td>
	</tr>)
}

const getYears = () => {
	const years = []
	const date = new Date()
	for(let i=date.getFullYear(); i>1970; i--) {
		years.push({id: i, name: i})
	}
	return years
}

const formatDate = (v) => {
	const dt = new Date(v)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m}/${d}/${dt.getFullYear()}`
	return dFormat
}


const formatCurrency = (value) => {
	if(value == null) {
		return
	}
	value += ''
	let v = value.replace(/,/g, "")
	if(!v.includes('.')) {
		v += ".00"
	}
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const exportToCSV = (csvData, filename, typeId, dateRange, year, focusCrop, dateTime) => {
	let totalClusters = 0
	let totalSites = 0
	let tempCSVData = csvData
	if(!Array.isArray(tempCSVData)) {
		tempCSVData = csvData.clusters
	}
	tempCSVData.map((item, i) => {
		if(item.cluster_count != null) {
			totalClusters += item.cluster_count
		}
		else if(item.cluster_involved != null) {
			totalClusters += item.cluster_involved
		}
		if(item.site_count != null) {
			totalSites += item.site_count
		}
		else if(item.site_involved != null) {
			totalSites += item.site_involved
		}
	})
	const user = JSON.parse(sessionStorage.getItem("user"))
	const data = []
	switch(typeId) {
		case 1:
			data.push(["REGION"])
			data.push([user.region.replace(/\s+/g, '%20')])
			data.push([])
			data.push(["REGISTERED%20FARMERS"])
			data.push([,,,"ARBs",,,"NON-ARBs"])
			data.push(['PROVINCE',"MUNICIPALITY","SITE%20NAME","MALE","FEMALE","TOTAL","MALE","FEMALE","TOTAL","Rural%20women%20under%20special%20circumstances%20(ARB%20and%20Non-ARB)","TOTAL"])
			csvData.map((item, i) => {
				data.push([item.province.replace(/\s+/g, '%20'),item.city.replace(/\s+/g, '%20'),item.site.replace(/\s+/g, '%20'),item.arb_male,item.arb_female,item.total_arb,item.non_arb_male,item.non_arb_female,item.total_non_arb,item.rural_women_with_circumstance,item.total_registered])
			})
		break
		case 2:
			data.push(["REGION","PROVINCE"])
			data.push([user.region.replace(/\s+/g, '%20'),user.province.replace(/\s+/g, '%20')])
			data.push([])
			data.push(["TOTAL%20CLUSTER%20MEMBERS%20AND%20OFFICERS"])
			data.push([,,,"ARBs",,,"NON-ARBs",,,,,"ARB%20Representative"])
			data.push(["PROVINCE","NUMBER%20OF%20SITES","NUMBER%20OF%20CLUSTERS","MALE","FEMALE","TOTAL","MALE","FEMALE","TOTAL","Rural%20women%20under%20special%20circumstances%20(ARB%20and%20Non-ARB)","TOTAL","MALE","FEMALE","TOTAL"])
			csvData.map((item, i) => {
				console.log(item)
				data.push([item.province.replace(/\s+/g, '%20'),item.site.replace(/\s+/g, '%20'),item.cluster_count,item.arb_male,item.arb_female,item.total_arb,item.non_arb_male,item.non_arb_female,item.total_non_arb,item.rural_women_with_circumstance,item.total_clustered,item.non_arb_male,item.non_arb_female,item.total_non_arb])
			})
		break
		case 3:
			data.push(["REGION","TOTAL%20NO.%20OF%20SITES","TOTAL%20NO.%20OF%20CLUSTERS","DATE%20RANGE"])
				data.push([user.region.replace(/\s+/g, '%20'),totalSites,totalClusters,dateRange.replace(/\s+/g, '%20')])
				data.push([])
				data.push(["COLLECTIVE%20MARKETING%20-%20CLUSTERS%20INVOLVED"])
				data.push([,,"ARBs",,,"NON-ARBs"])
				data.push(["PROVINCE","NUMBER%20OF%20SITES","NUMBER%20OF%20CLUSTERS","MALE","FEMALE","TOTAL","MALE","FEMALE","TOTAL","Rural%20women%20under%20special%20circumstances%20(ARB%20and%20Non-ARB)","TOTAL","TOTAL%20GROSS%20INCOME","TOTAL%20NET%20INCOME"])
				csvData.clusters.map((item, i) => {
					data.push([item.province.replace(/\s+/g, '%20'),item.site_involved,item.cluster_involved,item.arb_male,item.arb_female,item.total_arb,item.non_arb_male,item.non_arb_female,item.total_non_arb,item.rural_women_with_circumstance,item.total_involved,item.gross_income,item.net_income])
				})
		break
		case 4:
		break
		case 5:
			data.push(["REGION","TOTAL%20NO.%20OF%20SITES","TOTAL%20NO.%20OF%CLUSTERS","FOCUS%20CROP","DATE%20RANGE"])
			data.push([user.region.replace(/\s+/g, '%20'),totalSites,totalClusters,focusCrop,dateRange.replace(/\s+/g, '%20')])
			data.push([])
			data.push(["COMMITMENTS%200PER%20SITE"])
			data.push(["PROVINCE","TOTAL%20NO.%20OF%SITES","TOTAL%20NO.%20OF%20CLUSTERS","TOTAL%20AREA%20PLANTED","COMMITEMENT%20VOLUME","FINAL%20COMMITTED%20VOLUME"])
			csvData.map((item, i) => {
				data.push([item.province.replace(/\s+/g, '%20'),item.site_count,item.cluster_count,item.area_planted,item.supply_commitment,item.evaluated_supply])
			})
		break
		case 6:
			data.push(["REGION","TOTAL%20NO.%20OF%20SITES"])
			data.push([user.region.replace(/\s+/g, '%20'),totalSites])
			data.push([])
			data.push(["SITE%20WORKING%20GROUP%20MEMBERS"])
			data.push([,,"SWGs"])
			data.push(["PROVINCE","NUMBER%20OF%20SITES","MALE","FEMALE","IN%20AN%20ORGANIZATION","TOTAL"])
			csvData.map((item, i) => {
				data.push([item.province.replace(/\s+/g, '%20'),item.site_count,item.male,item.female,item.in_organization,item.total])
			})
		break
		case 7:
			data.push(["REGION","TOTAL%20NO.%20OF%20SITES"])
			data.push([user.region.replace(/\s+/g, '%20'),totalSites])
			data.push([])
			data.push(["TOTAL%20NO.%20OF%20ORGANIZATIONS"])
			data.push([,,"ARBO%20TYPE"])
			data.push(["PROVINCE","NUMBER%20OF%20SITES","ARB%20COOP","CONSUMER","CREDIT","FARMER%20MPC","MARKETING","MULTI%20PURPOSE%20(AGRI)","MULTI%20PURPOSE%20(NON-AGRI)","PRODUCERS",'TOTAL%20NO.%20OF%20ORGANIZATIONS'])
			csvData.map((item, i) => {
				data.push([item.province.replace(/\s+/g, '%20'),item.site_count,item.arb_cooperative,item.consumer,item.credit,item.farmers_mpc,item.marketing,item.multi_purpose_agri,item.multi_purpose_non_agri,item.producers,item.total])
			})
	}
	data.push([])
	data.push(['Date%20Generated: ', `${dateTime.toDateString()} ${dateTime.toLocaleTimeString()}`.replace(/\s+/g, '%20')])
	var csvRow = [];
	for(const v of data) {
		csvRow.push(v.join(","));
	}
	var csvString = csvRow.join("%0A");
	var a = document.createElement('a');
	a.href = 'data:attachment/csv,' + csvString;
	a.target = "_Blank";
	a.download = filename + ".csv";
	a.click();
}

export default ReportsRegional
